import { Component, ViewChild } from '@angular/core';
import { FileTypeConstants } from '../../../shared/constants/file-upload-type-constants';
import { FileUploadComponent } from '../../../shared/file-upload/file-upload.component';

@Component({
  selector: 'claim-pictures',
  templateUrl: './claim-pictures.component.html',
})
export class ClaimPicturesComponent {
  @ViewChild(FileUploadComponent) fileUpload: FileUploadComponent;

  public formCompleted = false;  
  public acceptedFiles: string[] = FileTypeConstants.accceptedImageTypes;

  constructor() { }

  public validateForm(): void {
    this.fileUpload.validateForm();
  }

  public reset(): void {
    this.fileUpload.clearFiles();
  }
}